// extracted by mini-css-extract-plugin
module.exports = {"root":"_2ZRUQ","content-wrapper":"_1Yz3d","contentWrapper":"_1Yz3d"};